module.exports = require("zip-dir");


//////////////////
// WEBPACK FOOTER
// external "zip-dir"
// module id = 135
// module chunks = 0